import React from "react";
import "./userProfile.scss";
import AccountIcon from "../../assets/images/AccountIcon";
import SecurityIcon from "../../assets/images/SecurityIcon";
import LayoutGrid from "../../assets/images/LayoutGrid";
import ProfileInfo from "./ProfileInfo";
import Password from "./password";
import ListTabView from "../../components/common/tabView";
import TabHeaderView from "../../components/common/tabHeaderView";
import UserProfileCamps from "./UserProfileCamps";
import UserNotification from "./UserNotification";
import { NotificationIcon } from "../../assets/images/NotificationIcon";

const UserProfile = () => {
  return (
    <>
      <ListTabView
        defaultIndex={0}
        listComponent={[
          {
            header: (
              <TabHeaderView
                iconHtml={
                  <span className="pr-2">
                    <AccountIcon />
                  </span>
                }
                title={"Account"}
              />
            ),
            content: <ProfileInfo />,
          },
          {
            header: (
              <TabHeaderView
                iconHtml={
                  <span className="pr-2">
                    <SecurityIcon />
                  </span>
                }
                title={"Security"}
              />
            ),
            content: <Password />,
          },
          {
            header: (
              <TabHeaderView
                iconHtml={
                  <span className="pr-2">
                    <LayoutGrid />
                  </span>
                }
                title={"Camps"}
              />
            ),
            content: <UserProfileCamps />,
          },
           {
            header: (
              <TabHeaderView
                iconHtml={
                  <span className="pr-2">
                    <NotificationIcon />
                  </span>
                }
                title={"Notification"}
              />
            ),
            content: <UserNotification />,
          },
        ]}
      />
    </>
  );
};

export default UserProfile;
